import { gql } from "@apollo/client";

export const GET_TOKEN = gql`
  query GetToken($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      response
      refresh
      expireHours
      userInfo {
        salesPersonGuid
        salesPersonName
        salesRegionHierarchyCode
        salesRegionReference
        salesRegionDisplayName
        roles
        tenantId
        rolesGuids
        sessionGuid
      }
    }
  }
`;

export const GET_STATEMENTS = gql`
  query GetStatements($activityId: Int) {
    activityStatements(where: { activityId: { eq: $activityId } }) {
      edges {
        node {
          statementCode
          statementText
          value
          guid
        }
      }
    }
  }
`;

export const GET_GUID = gql`
  query GetGuid($activityId: Int) {
    activities(where: { activityId: { eq: $activityId } }) {
      edges {
        node {
          guid
        }
      }
    }
  }
`;

export const GET_ACTIVITIES = gql`
  query GetActivities(
    $cursor: String
    $salesPersonGuid: UUID
    $activityTypeGuid: UUID
  ) {
    activities(
      after: $cursor
      where: {
        createSalesPerson: { guid: { eq: $salesPersonGuid } }
        activityType: { guid: { eq: $activityTypeGuid } }
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          createSalesPerson {
            name
          }
          guid
          updateVersion
          activityId
          projectId
          childActivities {
            updateVersion
            activityStatusReason {
              displayName
            }
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }

              documentId
              activityStatement {
                statementCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText
              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
          planDateTime
          planEndDateTime
          activityStatusId
          customer {
            displayName
            guid
            customerCategoryId
            customerTypeId
            customerReference
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid
              activityStatementId
              document {
                guid
                fileName
              }
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`;

export const GET_SELECTED_ACTIVITY = gql`
  query GetActivities($activityGuid: UUID) {
    activities(where: { guid: { eq: $activityGuid } }) {
      edges {
        node {
          activityId
          guid
          updateVersion
          projectId
          planDateTime
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatusId

          activityStatements {
            guid
            titleText
            value
            dataType
            statementText
            statementCode
            notes
          }
          childActivities {
            updateVersion
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText

              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_CURRENT_ACTIVITIES_FOR_CHILD = gql`
  query GetActivities($activityGuid: UUID) {
    activities(where: { guid: { eq: $activityGuid } }) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          guid
          updateVersion
          childActivities {
            guid
            updateVersion
          }
        }
      }
    }
  }
`;

export const GET_ACTIVITIES_FOR_PARENT_CHILD = gql`
  query GetActivities($cursor: String, $activityTypeGuid: UUID) {
    activities(
      after: $cursor
      where: { activityType: { guid: { eq: $activityTypeGuid } } }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          guid
          activityDocuments {
            guid
            document {
              fileName
              guid
              originalFileName
              documentTypeCode
            }

            documentId
            activityStatement {
              statementCode
            }
          }
          updateVersion
          activityId
          createSalesPerson {
            name
          }
          planDateTime
          activityStatusId
          customer {
            displayName
            guid
          }
          childActivities {
            updateVersion
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }

              documentId
              activityStatement {
                statementCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText

              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid

              activityStatementId
              document {
                guid
                originalFileName
                fileName
              }
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`;
/* export const GET_ACTIVITIES_FOR_PARENT_CHILD = gql`
  query GetActivities(
    $cursor: String
    $salesPersonGuid: UUID
    $activityTypeGuid: UUID
  ) {
    activities(
      after: $cursor
      where: {
        salesPerson: { guid: { eq: $salesPersonGuid } }
        activityType: { guid: { eq: $activityTypeGuid } }
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          guid
          activityDocuments {
            guid
            document {
              fileName
              guid
              originalFileName
              documentTypeCode
            }

            documentId
            activityStatement {
              statementCode
            }
          }
          updateVersion
          activityId
          createSalesPerson {
            name
          }
          planDateTime
          activityStatusId
          customer {
            displayName
            guid
          }
          childActivities {
            updateVersion
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }

              documentId
              activityStatement {
                statementCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText

              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid

              activityStatementId
              document {
                guid
                originalFileName
                fileName
              }
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`; */

export const GET_ACTIVITIES_WITH_STATUSID = gql`
  query GetActivities(
    $cursor: String
    $activityTypeGuid: UUID
    $activityStatusGuid: UUID
  ) {
    activities(
      after: $cursor
      where: {
        activityStatus: { guid: { eq: $activityStatusGuid } }
        activityType: { guid: { eq: $activityTypeGuid } }
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          guid
          planDateTime
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          activityDocuments {
            guid
            document {
              fileName
              guid
              originalFileName
              documentTypeCode
            }

            documentId
            activityStatement {
              statementCode
            }
          }
          updateVersion
          activityId
          createSalesPerson {
            name
          }

          activityStatusId
          customer {
            displayName
            guid
          }
          childActivities {
            updateVersion
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }

              documentId
              activityStatement {
                statementCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText

              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid

              activityStatementId
              document {
                guid
                originalFileName
                fileName
              }
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`;

export const GET_MULTIPLE_ACTIVITIES_FOR_DRAFT = gql`
  query {
    activities(
      where: {
        activityStatus: {
          guid: {
            in: [
              "3F45C1CC-CB37-4D7C-AF74-ECDB52C114C7"
              "9053B89D-E43C-4ABD-82AC-C72D9FC0BC2D"
            ]
          }
        }
        activityType: { guid: { eq: "07EF8AFD-4944-4DB0-9773-E9A0A0CBD9CB" } }
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          guid
          planDateTime
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          activityDocuments {
            guid
            document {
              fileName
              guid
              originalFileName
              documentTypeCode
            }

            documentId
            activityStatement {
              statementCode
            }
          }
          updateVersion
          activityId
          createSalesPerson {
            name
          }

          activityStatusId
          customer {
            displayName
            guid
          }
          childActivities {
            updateVersion
            planDateTime
            activityType {
              guid
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
            }
            activityDocuments {
              guid
              document {
                fileName
                guid
                originalFileName
                documentTypeCode
              }

              documentId
              activityStatement {
                statementCode
              }
            }
            activityId
            activityStatusId
            guid
            activityStatements {
              titleText

              jsonValues {
                items {
                  option
                }
              }
              statementCode
              value
            }
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid

              activityStatementId
              document {
                guid
                originalFileName
                fileName
              }
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`;

export const GET_ACTIVITIES_WITH_UPDATE_VERSION_USING_GUIDS = gql`
  query GetActivities($activityGuid: UUID) {
    activities(where: { guid: { eq: $activityGuid } }) {
      edges {
        node {
          guid

          updateVersion
          childActivities {
            activityId
            guid
            updateVersion
          }
          activityId
        }
      }
    }
  }
`;

export const GET_CHILD_PARENT_ACTIVITY_DOCUMENTS = gql`
  query GetActivities($activityGuid: UUID) {
    activities(where: { guid: { eq: $activityGuid } }) {
      edges {
        node {
          guid
          activityDocuments {
            guid
            documentId
            activityStatement {
              statementCode
            }
            document {
              guid
              fileName
              originalFileName
              documentTypeCode
            }
          }
          activityId
          childActivities {
            activityId
            activityStatements {
              statementCode
              value
            }
            guid
            updateVersion
            activityDocuments {
              guid
              documentId
              activityStatement {
                statementCode
              }
              document {
                guid
                fileName
                originalFileName
                documentTypeCode
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_SALESPERSON_ID = gql`
  query ($guid: UUID!) {
    salesPeople(where: { guid: { eq: $guid } }) {
      edges {
        node {
          worksInCustomerId
        }
      }
    }
  }
`;

export const GET_UNIVERSITY_FACULTY = gql`
  query ($worksInCustomerID: Int) {
    customers(where: { customerId: { eq: $worksInCustomerID } }) {
      edges {
        node {
          displayName
          brandName
        }
      }
    }
  }
`;

export const GET_EMPTY_ACTIVITY = gql`
  query ($paramGuid: UUID!) {
    createEmptyActivity(activityTypeGuid: $paramGuid) {
      activityTypeGuid
      notes
      planDateTime
      planEndDateTime
      activityStatements {
        titleText
        statementCode
        statementText
        dataType
        notes

        jsonValues {
          items {
            option
          }
        }
      }
      avaibleEmptyActivityStatusModelList {
        displayName
        guid
        colorCode
        isCancelled
        isPlanned
        isInProgress
        isCompleted
        isClosed
      }
    }
  }
`;

export const GET_NESTED_ACTIVITY = gql`
  query GetActivities(
    $cursor: String
    $activityTypeGuid: UUID
    $activityStatusGuid: UUID
  ) {
    activities(
      after: $cursor
      where: {
        activityType: { guid: { eq: $activityTypeGuid } }
        activityStatus: { guid: { eq: $activityStatusGuid } }
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          activityId
          guid
          updateVersion
          parentActivity {
            planDateTime
            activityId
            activityType {
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
              guid
            }
            guid
            updateVersion
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
            activityStatements {
              statementCode
              value
              titleText
            }
            createSalesPerson {
              name
            }
            childActivities {
              activityId
              planDateTime
              activityType {
                guid
                workflow {
                  workflowId
                  activityStatusWorkflows {
                    toActivityStatusId
                    role
                  }
                }
              }
              guid
              activityStatusId
              activityStatus {
                activityStatusId
                guid
                displayName
                activityStatusWorkflowToActivityStatusesWf {
                  activityStatusWorkflowId
                  toActivityStatusId
                  isDefault
                  role
                }
              }
              activityStatements {
                statementCode
                value
                titleText
              }
              updateVersion
            }
          }
        }
      }
    }
  }
`;

export const GET_NESTED_ACTIVITY_SALESPERSON = gql`
  query GetActivities(
    $cursor: String
    $activityTypeGuid: UUID
    $activityStatusGuid: UUID
  ) {
    activities(
      after: $cursor
      where: {
        activityType: { guid: { eq: $activityTypeGuid } }
        activityStatus: { guid: { eq: $activityStatusGuid } }
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          activityId
          guid
          updateVersion
          salesPerson {
            guid
          }
          parentActivity {
            planDateTime
            activityId
            activityType {
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
              guid
            }
            guid
            updateVersion
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
            activityStatements {
              statementCode
              value
              titleText
            }
            createSalesPerson {
              name
            }
            childActivities {
              activityId
              planDateTime
              salesPerson {
                guid
              }
              activityType {
                guid
                workflow {
                  workflowId
                  activityStatusWorkflows {
                    toActivityStatusId
                    role
                  }
                }
              }
              guid
              activityStatusId
              activityStatus {
                activityStatusId
                guid
                displayName
                activityStatusWorkflowToActivityStatusesWf {
                  activityStatusWorkflowId
                  toActivityStatusId
                  isDefault
                  role
                }
              }
              activityStatements {
                statementCode
                value
                titleText
              }
              updateVersion
            }
          }
        }
      }
    }
  }
`;

export const GET_NESTED2_ACTIVITY = gql`
  query GetActivities(
    $cursor: String
    $activityTypeGuid: UUID
    $activityStatusId: Int
    $activityStatusId1: Int
  ) {
    activities(
      after: $cursor
      where: {
        activityType: { guid: { eq: $activityTypeGuid } }
        or: [
          { activityStatusId: { eq: $activityStatusId } }
          { activityStatusId: { eq: $activityStatusId1 } }
        ]
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          activityId
          guid
          updateVersion
          parentActivity {
            activityId
            activityType {
              workflow {
                workflowId
                activityStatusWorkflows {
                  toActivityStatusId
                  role
                }
              }
              guid
            }
            guid
            updateVersion
            activityStatus {
              activityStatusId
              guid
              displayName
              activityStatusWorkflowToActivityStatusesWf {
                activityStatusWorkflowId
                toActivityStatusId
                isDefault
                role
              }
            }
            activityStatements {
              statementCode
              value
              titleText
            }
            createSalesPerson {
              name
            }
            childActivities {
              activityId
              activityType {
                guid
                workflow {
                  workflowId
                  activityStatusWorkflows {
                    toActivityStatusId
                    role
                  }
                }
              }
              guid
              activityStatusId
              activityStatus {
                activityStatusId
                guid
                displayName
                activityStatusWorkflowToActivityStatusesWf {
                  activityStatusWorkflowId
                  toActivityStatusId
                  isDefault
                  role
                }
              }
              activityStatements {
                statementCode
                value
                titleText
              }
              updateVersion
            }
          }
        }
      }
    }
  }
`;

export const GET_ACTIVITY_TYPE_STATEMENTS = gql`
  query GetActivityTypeStatements(
    $cursor: String
    $activityTypeId: Int
    $titleText: String
  ) {
    activityTypeStatements(
      after: $cursor
      where: {
        activityTypeId: { eq: $activityTypeId }
        titleText: { eq: $titleText }
      }
      first: 30
    ) {
      edges {
        node {
          statementText
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
